import { normalizeEmotion } from "../../utils/emotion";
import { EMOJI_BY_EMOTION } from "./chunk-0.jsx";
export function espPresetPairFromEmotion(emotion, variant) {
  const e = normalizeEmotion(emotion);
  const both = name => ({
    left: name,
    right: name
  });
  const pair = (left, right) => ({
    left,
    right
  });

  // Default mapping aims to only use real presets from esp32-eyes (no fake emotions).
  // Some variants swap a couple presets to better match their reference repos.
  const base = (() => {
    switch (e) {
      case 'angry':
        return both('Preset_Angry');
      case 'sleepy':
        return pair('Preset_Sleepy_Alt', 'Preset_Sleepy');
      case 'sad':
        return both('Preset_Sad');
      case 'surprised':
        return both('Preset_Surprised');
      case 'confused':
        return pair('Preset_Suspicious_Alt', 'Preset_Suspicious');
      case 'thinking':
        return pair('Preset_Skeptic_Alt', 'Preset_Skeptic');
      case 'happy':
        return both('Preset_Happy');
      case 'laughing':
        return both('Preset_Glee');
      case 'loving':
        return both('Preset_Awe');
      case 'cool':
        return pair('Preset_Squint_Alt', 'Preset_Squint');
      case 'winking':
        return pair('Preset_Annoyed_Alt', 'Preset_Happy');
      case 'embarrassed':
        return pair('Preset_Unimpressed_Alt', 'Preset_Unimpressed');
      case 'relaxed':
        return both('Preset_Focused');
      case 'silly':
        return pair('Preset_Squint_Alt', 'Preset_Skeptic');
      case 'confident':
        return pair('Preset_Skeptic_Alt', 'Preset_Unimpressed');
      case 'delicious':
        return both('Preset_Awe');
      case 'neutral':
      default:
        return both('Preset_Normal');
    }
  })();
  if (variant === 'tft_espi') {
    if (e === 'angry') return both('Preset_Furious');
    if (e === 'sad') return pair('Preset_Worried_Alt', 'Preset_Worried');
    if (e === 'surprised') return both('Preset_Awe');
    if (e === 'winking') return pair('Preset_Annoyed_Alt', 'Preset_Happy');
    return base;
  }
  if (variant === 'lcd') {
    if (e === 'surprised') return both('Preset_Scared');
    if (e === 'sleepy') return pair('Preset_Sleepy_Alt', 'Preset_Sleepy');
    return base;
  }
  return base;
}
export function emojiFromEmotion(emotion) {
  return EMOJI_BY_EMOTION[normalizeEmotion(emotion)] || '😶';
}
